import { render, staticRenderFns } from "./TennisFilters.vue?vue&type=template&id=15873161&"
import script from "./TennisFilters.vue?vue&type=script&lang=js&"
export * from "./TennisFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports